// extracted by mini-css-extract-plugin
export default {"main":"page_main__PFec3","page_main__PFec3":"page_page_main__PFec3__PgnQ3"};